<template>
  <div>
    <v-layout align-center justify-center fill-height row>
      <v-flex>
        <p class="step-text">Step 1. Declaration</p>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-layout v-if="!isMyShipmentType" align-center fill-height row class="order-step1__switch">
      <div @click="recipientType = $recipientType.personal"
           class="pointer text-switch"
           :class="{'text-type-disable': !isPersonalType}">
        Personal
      </div>
      <div class="mx-3">
        <v-switch
          v-model="recipientType"
          :true-value="$recipientType.commercial"
          :false-value="$recipientType.personal"
          @change="emitChangeOrder"
        ></v-switch>
      </div>
      <div @click="recipientType = $recipientType.commercial"
           class="pointer text-switch"
           :class="{'text-type-disable':!isCommercialType}">
        Commercial
      </div>
    </v-layout>
    <v-layout order-step1__wrap
              :class="{'pt-2': isMyShipmentType}"
    >
      <v-flex>
        <div class="filter-label-text pb-2">Preferable currency<span class="red--text ml-1">*</span></div>
        <v-select
          :items="currencies"
          item-text="name"
          item-value="id"
          v-model="orderCurrencyModel"
          @change="emitChangeOrder"
          :disabled="readOnlyStep1"
          :class="[{'disable-select': readOnlyStep1}, 'text-field-sign-in rounder-select mb-4 pb-4']"
          flat
          solo
          full-width
        >
        </v-select>
      </v-flex>
    </v-layout>
    <v-layout order-step1__wrap>
      <v-flex :class="{'xs12 sm12 md9 order-step1__mr4': isCommercialType}">
        <div class="filter-label-text pb-2">Description<span class="red--text ml-1">*</span>
          <v-tooltip top dark max-width="350px">
            <template slot="activator">
              <v-icon color="#4caf50" style="margin-bottom: -5px">help_outline</v-icon>
            </template>
            <span>Only you can see the name of the package. Name your package according to your preferences, for instance, order or product number or customer's full name to identify the package easily.</span>
          </v-tooltip>
        </div>
        <v-text-field
          id="orderName"
          name="orderName"
          v-model="orderNameModel"
          :rules="orderNameRules"
          @input="emitChangeOrder"
          placeholder="iPhone Xr 256gb"
          type="text"
          :disabled="readOnlyStep1"
          class="text-field-sign-in text-fields-add-order mb-4"
          :class="{'disable-select': readOnlyStep1}"
          flat
          full-width
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 md3 v-if="isCommercialType">
        <add-order-commercial-invoice></add-order-commercial-invoice>
      </v-flex>
    </v-layout>
    <v-flex v-if="this.$store.getters.getPdf">
      <add-order-commercial-invoice-view></add-order-commercial-invoice-view>
    </v-flex>
    <v-layout order-step1__wrap>
      <v-checkbox
        v-model="isPolyBag"
        :disabled="!isAvailablePolyBag"
        flat
        full-width
        class="m-top-0"
        @change="emitChangeOrder"
      >
        <div slot="label">
          Remove the external box and put in a poly bag.
        </div>
        <div slot="append">
          <i :class="[{'disabled-checkbox-warn': readOnlyStep1}, 'checkbox-warn']">* Applies to Frankfurt shipments only</i>
        </div>
      </v-checkbox>
    </v-layout>
    <v-layout v-if="isOnlineType" class="order-step1__wrap">
      <v-flex xs12 sm12 md6 class="order-step1__mr4">
        <div class="filter-label-text pb-2">Tracking number
          <span slot="append">
            <i :class="[{'disabled-checkbox-warn': readOnlyStep1}, 'help-color']">* Only number without additional information </i>
          </span>
          <v-tooltip top dark max-width="350px">
            <template slot="activator">
              <v-icon color="#4caf50" style="margin-bottom: -5px">help_outline</v-icon>
            </template>
            <span>A tracking number, or a number for tracking your package, is issued by the online store a few days after placing your order. This number allows to easily identify your package at the H4B warehouse.</span>
          </v-tooltip>
        </div>
        <v-text-field
          id="trackingNumber"
          name="trackingNumber"
          v-model="trackingNumberModel"
          :rules="trackingNumberRules"
          @input="emitChangeOrder"
          placeholder="Tracking number"
          type="text"
          :disabled="readOnlyStep1 || isDetailsRequired"
          class="text-field-sign-in text-fields-add-order mb-4 pb-4"
          :class="{'disable-select': readOnlyStep1 || isDetailsRequired}"
          flat
          full-width
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 md6>
        <div class="filter-label-text pb-2">Site name<span class="red--text ml-1">*</span>
          <v-tooltip top dark max-width="350px">
            <template slot="activator">
              <v-icon color="#4caf50" style="margin-bottom: -5px">help_outline</v-icon>
            </template>
            <span>The site name is the name of the online store where the purchase was made.</span>
          </v-tooltip>
        </div>
        <v-text-field
          name="siteName"
          v-model="siteNameModel"
          @input="inputSiteName"
          :rules="siteNameRules"
          placeholder="amazon.com"
          type="text"
          :disabled="readOnlyStep1"
          class="text-field-sign-in text-fields-add-order mb-4"
          :class="{'disable-select': readOnlyStep1}"
          flat
          full-width
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-flex v-if="isCommercialType">
      <v-layout class="order-step1__wrap">
        <v-flex xs12 sm12 md6 class="order-step1__mr4">
          <div class="filter-label-text pb-2">Exporter Name
            <v-tooltip top dark max-width="350px">
              <template slot="activator">
                <v-icon color="#4caf50" style="margin-bottom: -5px">help_outline</v-icon>
              </template>
              <span>Exporter name is the name of the company or the name of an individual who is exporting</span>
            </v-tooltip>
          </div>
          <v-text-field
            v-model="exporterNameModel"
            :rules="exporterNameRules"
            @input="emitChangeOrder"
            id="exporterName"
            name="exporterName"
            placeholder="Exporter Name"
            type="text"
            class="text-field-sign-in text-fields-add-order mb-4 pb-4"
            flat
            full-width
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md6>
          <div class="filter-label-text pb-2">Exporter Address
            <v-tooltip top dark max-width="350px">
              <template slot="activator">
                <v-icon color="#4caf50" style="margin-bottom: -5px">help_outline</v-icon>
              </template>
              <span>Exporter Address is the address of the company or the address of an individual who is exporting</span>
            </v-tooltip>
          </div>
          <div
            class="v-input text-field-sign-in text-fields-add-order mb-4 pb-4 v-text-field v-text-field--full-width v-text-field--solo-flat v-text-field--enclosed theme--light">
            <div class="v-input__control">
              <div class="v-input__slot">
                <gmap-autocomplete
                    class="text-field-sign-in text-fields-add-order mb-4 pb-4 autocomplete-fields"
                    flat
                    full-width
                    classname="form-control"
                    placeholder="Start typing"
                    :value="exporterAddressModel"
                    id="exporterAddress"
                    @input="exporterAddressInput"
                    ref="autocomplete"
                    @place_changed="getAddressData"
                >
                </gmap-autocomplete>
              </div>
              <div class="v-text-field__details" style="margin-top: -30px">
                <div class="v-messages theme--light error--text">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message message-transition-enter-to" v-show="messages.exporterAddress">
                      {{ messages.exporterAddress }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-layout class="order-step1__wrap">
        <v-flex xs12 sm12 md6 class="order-step1__mr4">
          <div class="filter-label-text pb-2">Exporter Phone
            <v-tooltip top dark max-width="350px">
              <template slot="activator">
                <v-icon color="#4caf50" style="margin-bottom: -5px">help_outline</v-icon>
              </template>
              <span>Exporter Phone is the phone of the company or the phone of an individual who is exporting</span>
            </v-tooltip>
          </div>
          <vue-tel-input
            id="exporterPhone"
            name="exporterPhone"
            v-model="exporterPhoneModel"
            @onInput="onInputExporterPhone"
            class="text-field-sign-in phone-fields mb-1"
            flat
            full-width
            :defaultCountry="iso"
            :preferredCountries="['us', 'mn', 'krs']"
          >
          </vue-tel-input>
          <div class="v-text-field v-text-field--enclosed">
            <div class="v-text-field__details">
              <div class="error--text v-messages"><span
                v-show="messages.exporterPhone">{{ messages.exporterPhone }}</span></div>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm12 md6>
          <div class="filter-label-text pb-2">Exporter TAX ID
            <v-tooltip top dark max-width="350px">
              <template slot="activator">
                <v-icon color="#4caf50" style="margin-bottom: -5px">help_outline</v-icon>
              </template>
              <span>Exporter TAX ID is the TAX ID of the company or the TAX ID of an individual who is exporting</span>
            </v-tooltip>
          </div>
          <v-text-field
            id="itemName"
            name="employeeId"
            v-model="employeeIdModel"
            placeholder="Employee ID / Tax ID"
            :rules="employeeIdRules"
            @input="emitChangeOrder"
            class="text-field-sign-in text-fields-add-order mb-2"
            flat
            full-width
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-text-field
      v-show="false"
      :error-messages="messages.exporterPhone || messages.exporterAddress"
      :rules="validationFormRules"
    ></v-text-field>

    <v-layout class="order-step1__wrap" v-if="isMyShipmentType">
      <v-flex xs12 sm12 md3 pr-sm-2>
        <div class="filter-label-text pb-2">
          Height<span class="red--text ml-1" v-if="orderType === $orderType.myShipmentLabel">*</span>
          <v-tooltip top dark max-width="350px">
            <template slot="activator">
              <v-icon color="#4caf50" style="margin-bottom: -5px">help_outline</v-icon>
            </template>
            <span>Height</span>
          </v-tooltip>
        </div>
        <v-text-field
            id="height"
            name="height"
            v-model="heightModel"
            placeholder="Height"
            @input="emitChangeOrder"
            :rules="heightRules"
            class="text-field-sign-in text-fields-add-order mb-4"
            flat
            full-width
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm12 md3 pr-sm-2>
        <div class="filter-label-text pb-2">
          Width<span class="red--text ml-1" v-if="orderType === $orderType.myShipmentLabel">*</span>
          <v-tooltip top dark max-width="350px">
            <template slot="activator">
              <v-icon color="#4caf50" style="margin-bottom: -5px">help_outline</v-icon>
            </template>
            <span>width</span>
          </v-tooltip>
        </div>
        <v-text-field
            id="width"
            name="width"
            v-model="widthModel"
            placeholder="Width"
            @input="emitChangeOrder"
            :rules="widthRules"
            class="text-field-sign-in text-fields-add-order mb-4"
            flat
            full-width
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm12 md3 pr-sm-2>
        <div class="filter-label-text pb-2">
          Length<span class="red--text ml-1" v-if="orderType === $orderType.myShipmentLabel">*</span>
          <v-tooltip top dark max-width="350px">
            <template slot="activator">
              <v-icon color="#4caf50" style="margin-bottom: -5px">help_outline</v-icon>
            </template>
            <span>length</span>
          </v-tooltip>
        </div>
        <v-text-field
            id="length"
            name="length"
            v-model="lengthModel"
            placeholder="Length"
            @input="emitChangeOrder"
            :rules="lengthRules"
            class="text-field-sign-in text-fields-add-order mb-4"
            flat
            full-width
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm12 md3>
        <div class="filter-label-text pb-2">
          Weight<span class="red--text ml-1" v-if="orderType === $orderType.myShipmentLabel">*</span>
          <v-tooltip top dark max-width="350px">
            <template slot="activator">
              <v-icon color="#4caf50" style="margin-bottom: -5px">help_outline</v-icon>
            </template>
            <span>weight</span>
          </v-tooltip>
        </div>
        <v-text-field
            id="weight"
            name="weight"
            v-model="weightModel"
            placeholder="weight"
            @input="emitChangeOrder"
            :rules="weightRules"
            class="text-field-sign-in text-fields-add-order mb-4"
            flat
            full-width
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout v-if="isMyShipmentType" align-center fill-height row class="order-step1__switch">
      <div @click="isMetric = 1"
           class="pointer text-switch"
           :class="{'text-type-disable': isMetric !== 1}">
        Cm/KG
      </div>
      <div class="mx-3">
        <v-switch
            v-model="isMetric"
            :true-value="0"
            :false-value="1"
            @change="emitChangeOrder"
        ></v-switch>
      </div>
      <div @click="isMetric = 0"
           class="pointer text-switch"
           :class="{'text-type-disable': isMetric !== 0}">
        Inch/LB
      </div>
    </v-layout>

    <v-divider></v-divider>

    <v-flex>
      <product-list
        ref="productListRef"
        :products="products"
        :recipientType="recipientType"
        :isDetailsRequired="isDetailsRequired"
        :orderType="orderType"
        @change="updateProduct"
        :readOnly="readOnlyStep1"
        :categories="categories"
        :currencies="currencies"
        :selectedCurrencyId="orderCurrencyModel"
        :validDescriptions="validDescriptions"
      ></product-list>
    </v-flex>
  </div>
</template>

<script>
  import VueTelInput from 'vue-tel-input';
  import ProductList from '@/components/User/Orders/ProductList'
  import addOrderCommercialInvoice from '@/components/User/Orders/AddOrderCommercialInvoice'
  import addOrderCommercialInvoiceView from '@/components/User/Orders/AddOrderCommercialInvoiceView'
  import OrdersService from '@/services/Orders'

  export default {
    name: "FormOrderStep1",
    components: {
      VueTelInput,
      ProductList,
      addOrderCommercialInvoice,
      addOrderCommercialInvoiceView
    },
    props: ['order', 'readOnlyStep1', 'isDetailsRequired', 'validDescriptions'],
    data() {
      return {
        isPolyBag: false,
        trackingNumberModel: null,
        siteNameModel: null,
        orderNameModel: null,
        orderCurrencyModel: null,
        exporterNameModel: null,
        exporterAddressModel: null,
        exporterAddressFlag: false,
        exporterPhoneModel: null,
        employeeIdModel: null,
        products: [],
        recipientType: null,
        orderType: null,
        categories: [],
        currencies: [],
        messages: {
          exporterAddress: null
        },
        iso: 'mn',
        //height width length weight
        heightModel: null,
        widthModel: null,
        lengthModel: null,
        weightModel: null,
        isMetric: 1
      }
    },
    mounted() {
      this.$store.commit('setLoading', true)
      OrdersService.getCreateData()
        .then(response => {this.categories = response.data.data.product_types; this.currencies = response.data.data.currencies; this.orderCurrencyModel = this.order.currency_id ? this.order.currency_id : this.currencies[0].id; this.$store.commit('setLoading', false)})
          // eslint-disable-next-line no-console
        .catch(err => console.log(err))
    },

    computed: {
      isPersonalType() {
        return this.recipientType === this.$recipientType.personal
      },
      isCommercialType() {
        return this.recipientType === this.$recipientType.commercial
      },
      isShipmentType() {
        return this.orderType === this.$orderType.shipment
      },
      isOnlineType() {
        return this.orderType === this.$orderType.online
      },
      isMyShipmentType() {
        return (this.orderType === this.$orderType.myShipmentLabel) || this.orderType === this.$orderType.myShipmentDropOff
      },
      isAvailablePolyBag() {
        return this.orderCurrencyModel === 2 && !this.readOnlyStep1;
      },

      orderNameRules() {
        return [
          v => !!v || 'Order name is required',
          v => (!!v && v.toString().trim().length >= 3) || 'Order name must be equal or more than 3 characters'
        ]
      },
      trackingNumberRules() {
        if (this.readOnlyStep1 || this.isDetailsRequired) {
          return [];
        }else {
          return [
            // eslint-disable-next-line no-useless-escape
            v => !v || (!!v && /^[A-Za-z0-9\-]+$/.test(v)) || 'Tracking number must contain only numbers, letters and dashes',
            v => !v || (!!v && v.toString().trim().length >= 3) || 'Tracking number must be equal or more than 3 characters'
          ]
        }
      },
      siteNameRules() {
        return [
          v => !!v || 'Site name is required',
          // eslint-disable-next-line no-useless-escape
          v => (!!v && /^(!?:(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|www\.))?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?$/.test(v)) || 'Site name must be valid',
          v => (!!v && v.toString().trim().length >= 3) || 'Site name must be equal or than 3 characters'
        ]
      },
      exporterNameRules() {
        return [
          v => !v || (!!v && v.toString().trim().length >= 3) || 'Exporter name must be equal or more than 3 characters'
        ]
      },
      employeeIdRules() {
        return [
          v => !v || (!!v && v.toString().trim().length >= 3) || 'Employee ID must be equal or more than 3 characters'
        ]
      },
      heightRules() {
        if (this.readOnlyStep1 || this.isDetailsRequired) {
          return [];
        }
        if (this.orderType === this.$orderType.myShipmentDropOff) {
          return [
            v => !v || (!!v && /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/.test(v)) || 'Height not valid',
          ]
        }
        return [
          v => !!v || 'Height is required',
          v => (!!v && /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/.test(v)) || 'Height not valid',
        ]
      },
      widthRules() {
        if (this.readOnlyStep1 || this.isDetailsRequired) {
          return [];
        }
        if (this.orderType === this.$orderType.myShipmentDropOff) {
          return [
              v => !v || (!!v && /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/.test(v)) || 'Width not valid',
          ];
        }
        return [
          v => !!v || 'Width is required',
          v => (!!v && /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/.test(v)) || 'Width not valid',
        ]
      },
      lengthRules() {
        if (this.readOnlyStep1 || this.isDetailsRequired) {
          return [];
        }
        if (this.orderType === this.$orderType.myShipmentDropOff) {
          return [
            v => !v || (!!v && /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/.test(v)) || 'Length not valid',
          ];
        }
        return [
          v => !!v || 'Width is required',
          v => (!!v && /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/.test(v)) || 'Length not valid',
        ]
      },
      weightRules() {
        if (this.readOnlyStep1 || this.isDetailsRequired) {
          return [];
        }
        if (this.orderType === this.$orderType.myShipmentDropOff) {
          return [
            v => !v || (!!v && /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/.test(v)) || 'Weight not valid',
          ];
        }
        return [
          v => !!v || 'Width is required',
          v => (!!v && /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/.test(v)) || 'Weight not valid',
        ]
      },
      validationFormRules() {
        return [
          () => (!this.messages.exporterAddress && !this.messages.exporterPhone) || 'Not valid form'
        ]
      }
    },
    created() {
      this.setDefaultValue()
    },
    watch: {
      order() {
        this.setDefaultValue()
      }
    },
    methods: {
      setDefaultValue() {
        this.isPolyBag = this.order.is_poly_bag || false
        this.trackingNumberModel = this.order.tracking_number_external || null
        this.siteNameModel = this.order.site_url || null
        this.orderNameModel = this.order.name || null
        this.orderCurrencyModel = this.order.currency ? this.order.currency.id : this.order.currency_id;

        if (typeof this.order.recipient_type === 'number') {
          this.recipientType = this.order.recipient_type ? this.$recipientType.commercial : this.$recipientType.personal
        } else {
          this.recipientType = this.order.recipient_type
        }
        this.orderType = this.order.flow_type
        if (typeof this.order.flow_type === 'number') {
          this.orderType = OrdersService.getOrderTypeByTypeId(this.order.flow_type);
        }

        if (this.$orderType.shipment === this.orderType) {
          this.products = this.order.items || []
        } else {
          this.products = this.order.products || []
        }

        //add hash for update price in screen
        if (this.products.length) {
          for (let i in this.products) {
            this.products[i].hash = parseInt(i) + 1
          }
        } else {
          this.products = [{hash: 1}]
        }

        this.exporterNameModel = this.order.exporter_name || null
        this.exporterAddressModel = this.order.exporter_address || null
        this.exporterPhoneModel = this.order.exporter_phone || null
        this.employeeIdModel = this.order.employee_id || null
        this.$store.commit('setLoading', false)

        if (!this.$store.getters.getPdf && this.order.commercial_invoice) {
          this.$store.dispatch('setPdf', this.order.commercial_invoice)
          this.order.commercial_invoice = null
        }
        this.widthModel = this.order.width || null
        this.heightModel = this.order.height || null
        this.lengthModel = this.order.length || null
        this.weightModel = this.order.package_weight || null
      },
      updateProduct(products) {
        this.products = products
        this.$emit('changeProducts', products)
      },
      exporterAddressInput(val) {
        this.messages.exporterAddress = 'Exporter address must be validate, select an address from the list'
        if (val.target.value == "") {
          this.exporterAddressModel = null
          this.messages.exporterAddress = null
          this.exporterAddressFlag = false
          this.emitChangeOrder()
        }
      },
      inputSiteName(siteName) {
        this.siteNameModel = siteName.toLowerCase().replace('http://', '').replace('https://', '').replace('www.', '').split(/[/?#]/)[0]
        this.emitChangeOrder()
      },
      getAddressData(placeResultData) {
        this.exporterAddressModel = placeResultData.formatted_address
        this.messages.exporterAddress = null
        this.exporterAddressFlag = true
        this.emitChangeOrder()
      },
      onInputExporterPhone({number, isValid}) {
        if (number) {
          let PhoneNumber = require('awesome-phonenumber')
          let phone = new PhoneNumber(number)
          if (isValid && phone.isValid()) {
            this.messages.exporterPhone = null
          } else {
            this.messages.exporterPhone = 'Phone number is not valid'
          }
        } else {
          this.messages.exporterPhone = null
        }
        this.emitChangeOrder()
      },
      scrollToFirstGlobalError() {
        if (this.$refs.productListRef && typeof this.$refs.productListRef.openPanelWithErrorAndScroll === 'function') {
          const errorHandledByProductList = this.$refs.productListRef.openPanelWithErrorAndScroll();
          if (!errorHandledByProductList) {
            this.scrollToErrorField();
          }
        } else {
          this.scrollToErrorField();
        }
      },
      scrollToErrorField() {
        setTimeout(function () {
          const errorElement = document.querySelector('.v-input.error--text');

          if (errorElement) {
            errorElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
        }, 100);
      },
      emitChangeOrder() {
        const order = {};
        if (this.trackingNumberModel) {
          order.tracking_number_external = this.trackingNumberModel;
        }
        if (this.siteNameModel) {
          order.site_url = this.siteNameModel;
        }

        order.is_poly_bag = this.isPolyBag;
        order.is_metric = this.isMetric;
        order.name = this.orderNameModel;
        order.currency = (this.currencies.length > 0 && this.orderCurrencyModel) ? this.currencies.filter(currency => currency.id == this.orderCurrencyModel)[0] : {};
        order.currency_id = order.currency.id ? order.currency.id : this.orderCurrencyModel;
        order.recipient_type = this.recipientType;

        if (this.order.flow_type === this.$orderType.shipment) {
          order.items = this.products;
        } else {
          order.products = this.products;
        }
        order.flow_type = this.order.flow_type;
        if (this.exporterNameModel) {
          order.exporter_name = this.exporterNameModel;
        }
        if (this.exporterAddressModel) {
          order.exporter_address = this.exporterAddressModel;
        }
        if (this.exporterPhoneModel) {
          order.exporter_phone = this.exporterPhoneModel;
        }
        if (this.employeeIdModel) {
          order.employee_id = this.employeeIdModel;
        }

        if (this.widthModel) {
          order.width = this.widthModel;
        }
        if (this.heightModel) {
          order.height = this.heightModel;
        }
        if (this.lengthModel) {
          order.length = this.lengthModel;
        }
        if (this.weightModel) {
          order.package_weight = this.weightModel;
        }
        this.$emit('change', order)
      }
    }
  }
</script>

<style scoped lang="stylus">
  .step-text
    height 28px
    color #252A30
    font-family Roboto
    font-size 24px
    font-weight bold
    line-height 28px

  .phone-fields
    border-radius 6px
    margin-bottom 0

  .autocomplete-fields
    border 0
    padding-top 15px

  .order-step1__wrap
    flex-wrap nowrap

  .order-step1__mr4
    margin-right 24px

  .disabled-checkbox-warn
    color #000000 !important

  .m-top-0 
    margin-top 0

  .checkbox-warn
    font-size 13px
    color red

  .pl-sm-2
    padding-left 8px !important

  .pr-sm-2
    padding-right 8px !important

  .help-color
    color #4caf50

  @media (max-width: 960px)
    .order-step1__switch
      justify-content center

    .order-step1__wrap
      flex-wrap wrap

    .order-step1__mr4
      margin-right 0

    .pl-sm-2
      padding-left 0 !important

    .pr-sm-2
      padding-right 0 !important
</style>
